// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global positional adjustments */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
* button {
  border: None;
  outline: None;
}
* p {
  margin-bottom: 0;
}

/* Colours to be used */
/* Common prefabs */
.RadioButtonSelector_container__Nwsqw {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.RadioButtonSelector_option__asiMU {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color-scheme: light;
  accent-color: #333;
  margin: 0;
}
.RadioButtonSelector_option__asiMU input[type=radio] {
  appearance: none;
  min-width: 1.5rem;
  min-height: 1.5rem;
  border: 1px solid lightgray;
  border-radius: 50%;
  transition-property: background-color, border-color, outline, outline-offset;
  transition-timing-function: ease-in;
  transition-duration: 100ms;
}
.RadioButtonSelector_option__asiMU input[type=radio]:checked {
  background-color: #BCCF00;
  box-shadow: 0 0 0 2px white inset;
  border-color: #BCCF00;
}
.RadioButtonSelector_option__asiMU input[type=radio]:not(:checked):hover {
  border-color: #BCCF00;
}
.RadioButtonSelector_option__asiMU input[type=radio]:focus-visible {
  outline: 1px dashed gray;
}`, "",{"version":3,"sources":["webpack://./src/utils/_base.scss","webpack://./src/components/Misc/RadioButtonSelector.module.scss"],"names":[],"mappings":"AAAA,kCAAA;AACA;EACI,SAAA;EACA,UAAA;EACA,sBAAA;ACCJ;ADCI;EACI,YAAA;EACA,aAAA;ACCR;ADEI;EACI,gBAAA;ACAR;;ADKA,uBAAA;AAQA,mBAAA;ACvBA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAeF;;AAZA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBDOU;ECNV,SAAA;AAeF;AAbE;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EAEA,2BAAA;EACA,kBAAA;EAEA,4EAAA;EACA,mCAAA;EACA,0BAAA;AAaJ;AAXI;EACE,yBAAA;EACA,iCAAA;EACA,qBAAA;AAaN;AAVI;EACE,qBAAA;AAYN;AATI;EACE,wBAAA;AAWN","sourcesContent":[null,"/* Global positional adjustments */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n* button {\n  border: None;\n  outline: None;\n}\n* p {\n  margin-bottom: 0;\n}\n\n/* Colours to be used */\n/* Common prefabs */\n.container {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.option {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color-scheme: light;\n  accent-color: #333;\n  margin: 0;\n}\n.option input[type=radio] {\n  appearance: none;\n  min-width: 1.5rem;\n  min-height: 1.5rem;\n  border: 1px solid lightgray;\n  border-radius: 50%;\n  transition-property: background-color, border-color, outline, outline-offset;\n  transition-timing-function: ease-in;\n  transition-duration: 100ms;\n}\n.option input[type=radio]:checked {\n  background-color: #BCCF00;\n  box-shadow: 0 0 0 2px white inset;\n  border-color: #BCCF00;\n}\n.option input[type=radio]:not(:checked):hover {\n  border-color: #BCCF00;\n}\n.option input[type=radio]:focus-visible {\n  outline: 1px dashed gray;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RadioButtonSelector_container__Nwsqw`,
	"option": `RadioButtonSelector_option__asiMU`
};
export default ___CSS_LOADER_EXPORT___;
